export default "__VITE_ASSET__CK6bZOWp__"